module.exports = __webpack_public_path__ + "static/assets/a84fcd3fcf5029253be648dded25e809.png";